<template>
  <div class="display-tabs text-left my-2">
    <small class="mx-2">{{hebrew ? 'תצוגה' : 'Display'}}</small>
    <b-button-group>
      <b-button 
        :class="{'btn-selected' : !graphDisplay, 'bg-white' : graphDisplay}"
        class="shadow-none px-0"
        @click="setDisplay(false)" >
        <i class="fas fa-bars"></i><span>שורות</span>
      </b-button>
      <b-button 
        :class="{'btn-selected' : graphDisplay, 'bg-white' : !graphDisplay}"
        class="shadow-none px-0"
        @click="setDisplay(true)" >
        <i class="fas fa-project-diagram"></i><span>גרף</span>
      </b-button>
    </b-button-group>    
  </div>
</template>

<script>
export default {
  name: 'DisplayTabs',
  props: {
    graphDisplay: {
      type: Boolean,
      default: false
      },  
    },
  data() {
    return {
      //showGraph: false
    }
  },
  mounted () {
    
  },
  methods: {
    setDisplay (graph) {
      //this.showGraph = graph
      this.$emit("toggle-graph", graph) 
    }
  },
  computed: {
    hebrew () {
      //return this.$settings.hebrew
      return true
    },
    mode: {
      get () {
        return this.graphDisplay
      },  
      set (value) {
        this.setDisplay(value)
        
      }  
    }     
  },
  watch: {

  }
}
</script>

<style scoped lang="scss">
  button {
    width: 70px;
    border-radius: 3px!important;
    border: solid 1px #c8c8c8;
    color: #000;
    &:first-child {
      border-top-left-radius: 0!important;
      border-bottom-left-radius: 0!important;
      border-left: none;
    }
    &:last-child {
      border-top-right-radius: 0!important;
      border-bottom-right-radius: 0!important;
    }
    &.btn-selected {
      background-color: #e3e3e3;
    }
    i {
      font-size: 11px;
      margin-left: 5px;      
    }
  }
</style>
